const DONATION_AUTHOR_ID_KEY = 'donation_author_id';
const DONATION_AUTHOR_NAME_KEY = 'donation_author_name';
const DONATION_TIME_KEY = 'donation_time';

export const DONATION_PENDING_TTL_MS = 20 * 60 * 1000; // 20 minutes

export type PendingDonationData = {
  authorId: string;
  authorName: string;
  time: number;
};

export function savePendingDonation(data: { authorId: string | number; authorName: string }): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(DONATION_AUTHOR_ID_KEY, String(data.authorId));
    localStorage.setItem(DONATION_AUTHOR_NAME_KEY, data.authorName);
    localStorage.setItem(DONATION_TIME_KEY, Date.now().toString());
  } catch (error) {
    console.error('[Donations] Error saving pending donation:', error);
  }
}

export function getPendingDonation(): PendingDonationData | null {
  if (typeof window === 'undefined') return null;

  try {
    const authorId = localStorage.getItem(DONATION_AUTHOR_ID_KEY);
    const authorName = localStorage.getItem(DONATION_AUTHOR_NAME_KEY);
    const timeRaw = localStorage.getItem(DONATION_TIME_KEY);

    if (!authorId || !authorName || !timeRaw) return null;

    const time = parseInt(timeRaw, 10);
    if (Number.isNaN(time)) return null;

    return { authorId, authorName, time };
  } catch (error) {
    console.error('[Donations] Error reading pending donation:', error);
    return null;
  }
}

export function clearPendingDonation(): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(DONATION_AUTHOR_ID_KEY);
    localStorage.removeItem(DONATION_AUTHOR_NAME_KEY);
    localStorage.removeItem(DONATION_TIME_KEY);
  } catch (error) {
    console.error('[Donations] Error clearing pending donation:', error);
  }
}

export function isPendingDonationFresh(
  time: number,
  ttlMs: number = DONATION_PENDING_TTL_MS,
): boolean {
  return Date.now() - time <= ttlMs;
}
